(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carnaval-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carnaval-sausage-roll')) {
    customElements.define(
      'carnaval-sausage-roll',
      class extends HTMLElement {
        connectedCallback() {
          this.observer = new IntersectionObserver(
            (entries) => {
              if (entries.some((entry) => entry.isIntersecting)) {
                this.setAttribute('data-landed', '');
                this.observer.disconnect();
              }
            },
            { rootMargin: '0px 0px -15% 0px' }
          );
          this.observer.observe(this.parentElement ?? this);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnaval-trailer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carnaval-trailer-player')) {
    customElements.define(
      'carnaval-trailer-player',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('button')?.addEventListener('click', () => this.load(), { once: true });
        }

        load() {
          const iframe = document.createElement('iframe');
          iframe.src = this.dataset.src;
          iframe.title = this.dataset.title || 'YouTube';
          iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          this.replaceChildren(iframe);
          iframe.focus();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-grid-player')) {
    customElements.define(
      'video-grid-player',
      class extends HTMLElement {
        connectedCallback() {
          // Keep the thumbnail button so the player can be reset after a swap.
          this.thumbnail ??= this.querySelector('button')?.cloneNode(true);
          this.bind();
        }

        bind() {
          const button = this.querySelector('button');
          if (button) button.onclick = () => this.select();
        }

        // A small video moves to the big spot at the top (swapping places with
        // the video there) and plays; the big one just plays.
        select() {
          const item = this.closest('.video-grid__item');
          const featured = item?.parentElement?.querySelector('.video-grid__item--featured');

          if (featured && featured !== item) {
            featured.querySelector('video-grid-player')?.reset();
            const featuredNodes = [...featured.childNodes];
            featured.replaceChildren(...item.childNodes);
            item.replaceChildren(...featuredNodes);
            featured.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }

          this.play();
        }

        reset() {
          if (!this.thumbnail || this.querySelector('button')) return;
          this.replaceChildren(this.thumbnail.cloneNode(true));
          this.bind();
        }

        play() {
          const id = encodeURIComponent(this.dataset.videoId);
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
          iframe.title = this.thumbnail?.getAttribute('aria-label') || 'YouTube';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          this.replaceChildren(iframe);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
